/**
 * AppointmentDetails
 *
 * Description: This component displays detailed information about a specific appointment. It includes a page header with a back button to navigate to the previous page and renders the `AppointmentDetailComponent` using the appointment ID.
 *
 * File Name: AppointmentDetails.tsx
 * Date: 16-09-2024
 */

import { RootState } from "src/Store/store";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "src/Components/Customer/PageHeader";
import AppointmentDetailComponent from "src/Components/GlobalComponents/AppointmentDetailComponent";
import BackIcon from "src/assets/images/back-icon.png";
import { useSelector } from "react-redux";

const AppointmentDetails: React.FC = () => {
  const { id = "" } = useParams(); // Extracting appointment ID from URL parameters
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const navigate = useNavigate(); // Hook to handle navigation

  // BackButton component for rendering the back icon in the page header
  const BackButton: React.FC = () => {
    return (
      <button
        className="right-bar-icon"
        onClick={() => navigate(-1)}
        // onClick={() => navigate(`/appointments`)}
      >
        <img src={BackIcon} alt="back-icon" />
      </button>
    );
  }; // display back icon in page header
  return (
    <>
      {/* Page header with a custom back button */}
      {userDetails?.userRole === "doctor" ? (
        <PageHeader
          title="My Appointments"
          isButton={true}
          ButtonComponent={BackButton}
        />
      ) : null}
      {/* Appointment detail view passing the appointment ID */}
      <div
        className={`${userDetails?.userRole === "customer" ? "inner-max-width box-design p-2 xl:p-4 my-2 xl:my-4" : "w-full parent-box"}`}
      >
        <AppointmentDetailComponent
          appoinmentId={id}
          mainContainerClass="!p-0 !bg-transparent !m-0 "
          type={userDetails?.userRole as "customer" | "doctor" | "operator" | "superAdmin"}
        />
      </div>
    </>
  );
};

export default AppointmentDetails;
